"use client"
import { generateNavLinks } from "@/lib/navigation-links"
import { useSisterSiteNavigation } from "@/utils/navbar/useSisterSiteNavigation"
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react"
import Hamburger from "hamburger-react"
import { useSession } from "next-auth/react"
import Link from "next/link"
import { FaChevronDown } from "react-icons/fa6"
import { match } from "ts-pattern"
import NewsletterFull from "../../Newsletter/Newsletter"
import { ContentNavItem, NavItem } from "@/types"
export function MobileMenu({
   isOpen,
   toggleMenuAction,
   isAuthenticated,
   latestVideoSlug,
}: {
   isOpen: boolean
   toggleMenuAction: () => void
   isAuthenticated?: boolean
   latestVideoSlug: string
}) {
   const { data: session } = useSession()
   const { jobs_session, training_session, webinars_session } = session || {}
   const { buildHandler } = useSisterSiteNavigation()
   // console.log("external sessions", JSON.stringify(session))

   const navigationLinks = generateNavLinks(latestVideoSlug, jobs_session, training_session, webinars_session)
   const isDevServer = process.env.NEXT_PUBLIC_NODE_ENV === "development"
   return (
      <div className="absolute left-0 right-0 top-0 z-50 bg-white">
         {/* topbar */}

         <div
            className={`${
               isOpen ? "flex" : "hidden"
            }  h-[55px] w-screen items-center justify-between bg-[#f5f5fa] py-3 pr-6`}
         >
            <Hamburger toggled={isOpen} toggle={toggleMenuAction} size={20} label="mobile menu" />
         </div>

         <div
            className={`
      ${isOpen ? "flex" : "hidden"}
      h-[calc(100vh-55px)]
      flex-col
      overflow-y-auto
      lg:hidden
   `}
         >
            <ol className="flex w-full flex-col divide-y-2">
               {navigationLinks.map((link: NavItem) => {
                  let baseHref = link.href ?? ""
                  if (isDevServer) {
                     if (link.title === "Events") {
                        baseHref = "https://qawebinar.restaurantassociation.com/"
                     } else if (link.title === "Jobs") {
                        baseHref = "https://qajobs.restaurantassociation.com/"
                     }
                  }
                  return !!link?.content ? (
                     <li className=" w-full" key={`${link.title}_mobile`}>
                        <Disclosure>
                           <DisclosureButton className="flex w-full items-center justify-between px-6 py-[.875rem]">
                              <span className="text-md text-left font-medium leading-6 tracking-[.4px] text-[#0a0a0a]">
                                 {link.title}
                              </span>
                              <FaChevronDown
                                 size={"20px"}
                                 color={"black"}
                                 className="transition-transform duration-300 ease-in-out ui-open:rotate-180 ui-open:transform"
                              />
                           </DisclosureButton>
                           <DisclosurePanel className=" ">
                              <ul className="divde-[#dddee6] flex flex-col divide-y bg-[#f5f5fa]">
                                 {link.content?.map((topic: ContentNavItem) => {
                                    return (
                                       <li key={`${topic.title}_mobile`}>
                                          <Link
                                             //@ts-ignore
                                             href={`${topic.href}` ?? "/"}
                                             className="flex items-center gap-1 pl-8"
                                             onClick={toggleMenuAction}
                                          >
                                             <topic.icon
                                                className="h-6 w-6 text-gray-600 group-hover:text-brandOrange"
                                                aria-hidden="true"
                                             />

                                             <span className="text-md block bg-[#f5f5fa] px-6 py-[.875rem] font-medium capitalize leading-6 tracking-[.4px] text-[#323239]">
                                                {topic.title}
                                             </span>
                                          </Link>
                                       </li>
                                    )
                                 })}
                              </ul>
                           </DisclosurePanel>
                        </Disclosure>
                     </li>
                  ) : (
                     <li
                        className="text-md list-none px-6 py-[.875rem] font-medium leading-6 tracking-[.4px] text-[#0a0a0a]"
                        key={`${link.title}_mobile`}
                     >
                        {match(link.title)
                           .with("Academy", () => (
                              <Link
                                 key={`${link.title}_desktop_nav`}
                                 href={baseHref}
                                 className="font-medium active:text-brand-black"
                                 onClick={buildHandler(baseHref, "training")}
                              >
                                 {link.title}
                              </Link>
                           ))
                           .with("Jobs", () => (
                              <Link
                                 key={`${link.title}_desktop_nav`}
                                 href={baseHref}
                                 className="font-medium active:text-brand-black"
                                 onClick={buildHandler(baseHref, "jobs")}
                              >
                                 {link.title}
                              </Link>
                           ))
                           .with("Events", () => (
                              <Link
                                 key={`${link.title}_desktop_nav`}
                                 href={baseHref || "/"}
                                 className="font-medium active:text-brand-black"
                                 onClick={buildHandler(baseHref, "events")}
                              >
                                 {link.title}
                              </Link>
                           ))
                           .otherwise(() => (
                              <Link
                                 href={baseHref || "/"}
                                 target={baseHref?.startsWith("http") ? "_blank" : "_self"}
                                 onClick={toggleMenuAction}
                              >
                                 {link.title}
                              </Link>
                           ))}
                     </li>
                  )
               })}
            </ol>
            {/* newsletter */}

            {!isAuthenticated && (
               <section
                  className="border-[#f5f5fa mb-8 border-y bg-[#f5f5fa]
          py-8"
               >
                  {/* Newsletter */}

                  <NewsletterFull />
               </section>
            )}
         </div>
      </div>
   )
}
